import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking (Counterparty  that has the greatest exposure to the AIF)',
    isStatic: false
  },
  counterparty_exposure_flag: {
    isStatic: false,
    name: 'Counterparty exposure flag (Counterparty  that has the greatest exposure to the AIF)'
  },
  counterparty_name: {
    name: 'Name of the counterparty that has the greatest exposure to the AIF',
    isStatic: false
  },
  counterparty_lei: {
    isStatic: false,
    name: 'LEI code of the counterparty that has the greatest exposure to the AIF'
  },
  counterparty_bic: {
    name: 'BIC code of the counterparty that has the greatest exposure to the AIF',
    isStatic: false
  },
  exposure_as_percentage_of_nav: {
    name: 'NAV percentage of the total exposure value of the counterparties that have the greatest exposure to the AIF',
    isStatic: false
  }
};

export function CountriesMarket({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.TOP_FIVE_COUNTRIES_COUNTERPARTY_EXPOSURE,
    onChangeFund,
    schema: schema.TOP_FIVE_COUNTRIES_COUNTERPARTY_EXPOSURE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TOP_FIVE_COUNTRIES_COUNTERPARTY_EXPOSURE
        ?.field_names || [],
    tableName: 'TOP_FIVE_COUNTRIES_COUNTERPARTY_EXPOSURE',
    columnLables,
    order: 166,
    isMultiFunds,
    funds
  });

  return (
    <StyledTables id="reporttables-countries-market-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'TOP_FIVE_COUNTRIES_COUNTERPARTY_EXPOSURE'}
          id={`reporttables-countries-market-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}
